import { marker } from '@colsen1991/ngx-translate-extract-marker';

const PUSH_TRANSLATIONS: string[] = [
    marker('push.success.add'),
    marker('push.success.change'),
    marker('push.success.delete'),
    marker('push.success.activate'),
    marker('push.success.password-change'),
    marker('push.success.user-role-add'),
    marker('push.success.user-role-remove'),
    marker('push.success.file-upload'),
    marker('push.success.file-upload-with-error'),
    marker('global.labels.no_data'),
    marker('push.success.validator-add'),
    marker('ui.table-uploads.status.success'),
    marker('push.success.success'),
    marker('push.success.change-status'),
    marker('push.success.transfer-ticket-success'),
    marker('push.success.block-client'),
    marker('push.success.unblock-client'),
    marker('push.success.personal-data-save'),
    marker('push.error.server'),
];

export enum PushCodeModel {
    SuccessAdd = 'push.success.add',
    SuccessChange = 'push.success.change',
    SuccessDelete = 'push.success.delete',
    SuccessActivate = 'push.success.activate',
    SuccessPasswordChange = 'push.success.password-change',
    SuccessUserRoleAdd = 'push.success.user-role-add',
    SuccessUserRoleDelete = 'push.success.user-role-remove',
    SuccessFileUpload = 'push.success.file-upload',
    SuccessFileUploadWithError = 'push.success.file-upload-with-error',
    NoData = 'global.labels.no_data',
    SuccessValidatorAdd = 'push.success.validator-add',
    SuccessStatus = 'ui.table-uploads.status.success',
    Success = 'push.success.success',
    SuccessChangeStatus = 'push.success.change-status',
    SuccessTransferTicket = 'push.success.transfer-ticket-success',
    SuccessBlockClient = 'push.success.block-client',
    SuccessUnblockClient = 'push.success.unblock-client',
    SuccessPersonalDataSave = 'push.success.personal-data-save',
    ErrorServer = 'push.error.server',
}
